import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { RootState } from "../../rootReducer";
import axiosInstance from "../../../utils/axiosConfig";

export const resetPassword = createAsyncThunk(
  "userShow/resetPassword",
  async (params, { getState, rejectWithValue }) => {
    try {
      const state = getState() as RootState;
      await axiosInstance.post(`${api.baseURL}user/restore-password`, {
        userId: state.userShow.user?.id,
      });
    } catch (error) {
      rejectWithValue(error);
      return error;
    }
  }
);
